<template>
  <div>
    <criterion-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.criterion_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import CriterionIndex from "./CriterionIndex";
import { CriterionCategoriesService } from "../../../services/criterionCategories.service";

export default {
  name: "Index",
  data() {
    return {
      serviceName: "criteria",
      formSearch: [
        {
          label: this.$t("criterion.name"),
          name: "name__~",
          value: "",
          type: "input"
        },
        {
          label: this.$t("criterion.category_name"),
          name: "criterion_category_id",
          value: "",
          type: "select",
          options: []
        }
      ],
      columns: {
        id: this.$t("criterion.id"),
        name: this.$t("criterion.name"),
        description: this.$t("criterion.description"),
        criterion_category_name: this.$t("criterion.category_name"),
        created_at: this.$t("criterion.created_at"),
        updated_at: this.$t("criterion.updated_at")
      }
    };
  },
  components: { CriterionIndex },
  methods: {
    async getCriteriaCategories() {
      const response = await new CriterionCategoriesService().getList({
        limit: 1000
      });
      this.formSearch[1].options = response.data || [];
      return response.data;
    }
  },
  mounted() {
    this.getCriteriaCategories();
  }
};
</script>
